import { render, staticRenderFns } from "./vote_confirm.vue?vue&type=template&id=e84bcf96&"
import script from "./vote_confirm.vue?vue&type=script&lang=js&"
export * from "./vote_confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports